// extracted by mini-css-extract-plugin
export default {"container":"CalendarBody--container--d0LQ5","week":"CalendarBody--week--KCtwH"};